var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-route-graph"},[_vm._t("default"),(_vm.currentPosition)?_c('div',{staticClass:"c-route-graph__current",style:({
      'left': _vm.currentPosition + '%'
    })},[_c('div',{staticClass:"c-route-graph__current-dot"}),_c('div',{staticClass:"c-route-graph__current-ripple"})]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }